/**
 * geometric-datasource.js
 * Used to handle iframe embed functionality for geometric
 * dataset interactive diagrams
 */

/**
 * Handler for when children iframes trigger a postmessage
 * @param {Object} event Event object from postmessage
 * @param {Object} event.data Data send from postmessage event
 */
function receiveMessage( { data } ) {

	// destructure height and id
	const { height, id } = data;

	// get all iframes
	const iframes = document.querySelectorAll( 'iframe' );

	// loop through iframes, find match from id to src
	[...iframes].some( iframe => {
		const src = iframe.getAttribute( 'src' );
		const srcArray = src.split( '/' );
		const lastChild = srcArray[srcArray.length-1];

		// go for resize
		if ( lastChild === id ) {
			iframe.height = height;
			iframe.setAttribute( 'scrolling','no' );
			iframe.setAttribute( 'verticalscrolling','no' );
			return true;
		}
	} );
}

/**
 * Setup function export
 */
export default function GeoDataIframeResizer() {
	window.addEventListener( 'message', receiveMessage, false );
}
